import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    reactor(this)
    this.outsideClick = this.outsideClick.bind(this)
    this.escape = this.escape.bind(this)
    this.resize = this.resize.bind(this)
    // Capture phase: toggle() calls stopPropagation(), which would block bubble-phase
    // document listeners. Capture still runs first so outside-click and exclusive-open
    // work when another rich-select / account menu trigger is clicked.
    document.addEventListener("click", this.outsideClick, true)
    document.addEventListener("keydown", this.escape)
    window.addEventListener("resize", this.resize)
    this.open ??= false
    this.render()
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick, true)
    document.removeEventListener("keydown", this.escape)
    window.removeEventListener("resize", this.resize)
  }

  resize() {
    if (this.open) this.render()
  }

  toggle(event) {
    event.stopPropagation()
    const next = !this.open
    if (next) this.closeOthers()
    this.open = next
    this.render()
    if (this.open) this.animateIn()
  }

  close() {
    if (!this.open) return
    this.open = false
    this.render()
  }

  // Enter/Space on a focusable option row (label) activates the nested control.
  // Radios in a group only put one input in the Tab order, so rows use tabindex=0
  // and leave the inputs at tabindex=-1.
  activateOption(event) {
    if (event.key !== "Enter" && event.key !== " ") return
    event.preventDefault()
    const control = event.currentTarget.querySelector("input, button, select, textarea")
    control?.click()
  }

  morph() {
    this.render()
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }

  // Only one popup open at a time (rich-select menus stack otherwise).
  closeOthers() {
    for (const controller of this.application.controllers) {
      if (controller.identifier !== "popup" || controller === this) continue
      controller.close?.()
    }
  }

  render() {
    this.menuTarget.classList.toggle("is-open", this.open)
    if (!this.open) this.menuTarget.classList.remove("just-opened")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.open ? "true" : "false")
    }
    this.constrainRichDropdown()
  }

  constrainRichDropdown() {
    const options = this.menuTarget.querySelector(".rich-dropdown-options")
    if (!options) return

    options.style.maxHeight = ""
    if (!this.open || window.innerWidth >= 1024) return

    const optionsTop = options.getBoundingClientRect().top
    const bottomBar = document.getElementById("mobile-bottom-bar")
    const bottom = bottomBar?.getBoundingClientRect().top ?? window.innerHeight
    const available = Math.floor(bottom - optionsTop - 8)
    options.style.maxHeight = `${Math.max(8, available)}px`
  }

  animateIn() {
    this.menuTarget.classList.remove("just-opened")
    void this.menuTarget.offsetWidth
    this.menuTarget.classList.add("just-opened")
  }
}
